import React,{useState} from 'react'
import '../assets/css/Panel.css'
import Navbar from "../components/Navbar";
import {useSelector,useDispatch} from "react-redux";
import {api} from "../utils/gashtaltAPI";
import {toast} from 'react-toastify';
import { updateName } from '../store/userSlice';
import UserImage from '../assets/images/user.svg'
import Loader from "../components/Loader";
function Profile() {
    const persianRegex = /[\u06A9\u06AF\u06C0\u06CC\u060C\u062A\u062B\u062C\u062D\u062E\u062F\u063A\u064A\u064B\u064C\u064D\u064E\u064F\u067E\u0670\u0686\u0698\u200C\u0621-\u0629\u0630-\u0639\u0641-\u0654]/;
    const [loading,setLoading] = useState(false);
    const dispatch = useDispatch();
    const {user} = useSelector((state) => state.user);
    const [name, setName] = useState(user.name);
    const [nameError, setNameError] = useState(false);
    const handleName = (e) => {
        const input = e.target.value;
        setNameError(!persianRegex.test(input));
        setName(input);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (name === "") {
            toast.error("نام و نام خانوادگی نمی تواند خالی باشد.", {
                position: "bottom-right"
            });
            return;
        }
        try {
            setLoading(true);
            const response = await api.post("/api/profile/update", {
                name: name
            });
            toast.success(response.data.message, {
                position: "bottom-right"
            });
            const updatedUser = { ...user, name: name };
            dispatch(updateName(updatedUser));
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status === 422 || status === 401) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }finally{
            setLoading(false);
        }
    };
    if (loading) return <Loader />
    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className='d-flex flex-column align-items-center mt-3 flex-fill pt-4'>
                <img src={UserImage} alt='خطا'  style={{width:'20vw'}}/>
                <form className='py-5 col-4' onSubmit={handleSubmit}>
                        <div className="custom-input-group">
                            <input type="text" className={`form-control ${nameError ? 'invalid' : ''}`}
                                   value={name}
                                   onChange={handleName}
                                   placeholder="نام و نام خانوادگی"/>
                            <p className={`form-error ${nameError ? 'visible' : 'hidden'}`}>نام و نام خانوادگی فقط می
                                تواند
                                شامل حروف فارسی باشد!</p>
                        </div>
                        <button className="submit-button btn btn-filled col-6 d-block mx-auto" type="submit">ثبت</button>
                </form>
            </div>
        </div>
    );
}

export default Profile;
